import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import PropTypes from 'prop-types';
import { Box, ListItem, ListItemAvatar, ListItemText, Skeleton } from '@mui/material';
import UserAvatar from '../UserAvatar';
const UserInfo = ({ item, avatarWrapper: AvatarWrapper, avatarWrapperProps }) => {
    return (_jsxs(ListItem, { component: 'div', title: item.Name, disableGutters: true, dense: true, children: [_jsx(ListItemAvatar, { children: _jsx(AvatarWrapper, Object.assign({}, avatarWrapperProps, { children: _jsx(UserAvatar, { user: item }) })) }), _jsx(ListItemText, { primary: item.Name, secondary: item.IsAccountDeleted ? null : item.Email })] }));
};
const UserInfoSkeleton = () => {
    return (_jsxs(ListItem, { component: 'div', disableGutters: true, dense: true, children: [_jsx(Skeleton, { variant: 'circular', width: 40, height: 40 }), _jsxs(Box, { ml: 2, children: [_jsx(Skeleton, { variant: 'text', width: 200 }), _jsx(Skeleton, { variant: 'text', width: 150 })] })] }));
};
UserInfo.defaultProps = {
    avatarWrapper: ({ children }) => children,
    avatarWrapperProps: {},
};
UserInfo.propTypes = {
    item: PropTypes.shape({
        Id: PropTypes.number,
        Name: PropTypes.string.isRequired,
        Email: PropTypes.string.isRequired,
        IsAccountDeleted: PropTypes.bool,
        AvatarUrl: PropTypes.string,
    }).isRequired,
    avatarWrapper: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.object.isRequired]),
    avatarWrapperProps: PropTypes.instanceOf(Object),
};
export default memo(UserInfo);
export { UserInfoSkeleton };
